exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tags-view-wrapper .tags-view-item .el-icon-close{width:16px;height:16px;vertical-align:2px;border-radius:50%;text-align:center;-webkit-transition:all .3s cubic-bezier(0.645, 0.045, 0.355, 1);transition:all .3s cubic-bezier(0.645, 0.045, 0.355, 1);-webkit-transform-origin:100% 50%;transform-origin:100% 50%}.tags-view-wrapper .tags-view-item .el-icon-close:before{-webkit-transform:scale(0.6);transform:scale(0.6);display:inline-block;vertical-align:-3px}.tags-view-wrapper .tags-view-item .el-icon-close:hover{background-color:#fa8c16;color:#fff}", ""]);

// exports
exports.locals = {
	"menuText": "#606266",
	"menuActiveText": "#fa8c16",
	"subMenuActiveText": "#fa8c16",
	"menuBg": "#fff",
	"menuHover": "#fff7e6",
	"subMenuBg": "#fafafa",
	"subMenuHover": "#fff7e6",
	"sideBarWidth": "220px",
	"primaryColor": "#fa8c16",
	"bgColor": "#fdfbf7"
};